var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton',{attrs:{"button":_vm.buttonLabel,"background":_vm.background},on:{"next":function($event){return _vm.$emit('next')}}},[_c('vv-tips',{attrs:{"title":_vm.title,"tips":_vm.stringTips}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }